import Svg, { SvgProps } from 'react-native-svg';

const NoIcon = (props: SvgProps) => <Svg width={24} height={24} {...props} />;

export default NoIcon;
